import { request } from "@/utils/request";

const isDev = process.env.VUE_APP_PREPATH !== "production";
const mockPartialPath = isDev ? "http://localhost:8080/mock" : "";
// const useMockList = ['queryTaskList', 'queryCardDetail', 'queryCardList','getProfileList','getProfileItem','getProfileContent'];
const useMockList = []
export const apiMap = {
  queryTaskList: "/taskapi/v1/carrier/user-task/list",
  queryCardDetail: "/v1/card/detail",
  queryCardList: "/v1/card/list-all",
  queryTaskInfo: "/taskapi/v1/user-task/info", // 根据任务Id获取任务信息 用于判断需不需要弹框
  reportPoped: "/taskapi/v1/user-task/popup/success", // 弹窗后上报已弹窗的状态
  querySkuInfo: "/v1/course/detail",
  querySkuList: "/v1/card/list",
  queryVideoInfo: "/v1/scan/video-detail",
  getProfileList:"/v1/user/privacy/profile-list",
  getProfileItem:"/v1/user/privacy/profile-item",
  getProfileContent:"/v1/user/privacy/profile-content",
  getPaperInfo: '/v1/paper/info', // 根据试卷id获取试卷内容
  submitAnswer: '/v1/paper/answer'
};
export const queryTaskList = (data: {
  carrier_id: string;
  carrier_type: number;
}) => {
  return request.get(
    `${useMockList.includes("queryTaskList") ? mockPartialPath : ""}${
      apiMap.queryTaskList
    }`,
    {
      ...data, 
      version: 1
    }
  );
};
export const queryCardDetail = (data: {unionid: string; column_unionid?: string;}) => {
  // console.log(`${useMockList.includes('queryCardDetail') ? mockPartialPath : ''}${apiMap.queryCardDetail}`)
  return request.post(`${useMockList.includes('queryCardDetail') ? mockPartialPath : ''}${apiMap.queryCardDetail}`, data)  
}
// 获取某个盒子下卡牌的所有id 用于切换上一个下一个
export const queryCardList = (data: {column_unionid: string;}) => {
  return request.post(`${useMockList.includes('queryCardList') ? mockPartialPath : ''}${apiMap.queryCardList}`, data)  
}
// 获取任务详情 判断需不需要弹框
export const queryTaskInfo = (data: {user_task_uuid: string; sub_uuid: string; is_recursive?: number }) => {
  data.is_recursive = data.is_recursive || 0
  console.log(`${useMockList.includes('queryTaskInfo') ? mockPartialPath : ''}${apiMap.queryTaskInfo}`)
  return request.get(`${useMockList.includes('queryTaskInfo') ? mockPartialPath : ''}${apiMap.queryTaskInfo}`, data)  
}
// 上报完成弹框
export const reportPoped = (data: {user_task_uuid: string; }) => {
  console.log(`${useMockList.includes('reportPoped') ? mockPartialPath : ''}${apiMap.reportPoped}`)
  return request.post(`${useMockList.includes('reportPoped') ? mockPartialPath : ''}${apiMap.reportPoped}`, data)  
}
// 根据资源id获取资源详情
export const queryVideoInfo = (data: {unionid?: string; nry_question_id?: string; }) => {
  console.log(`${useMockList.includes('queryVideoInfo') ? mockPartialPath : ''}${apiMap.queryVideoInfo}`)
  return request.post(`${useMockList.includes('queryVideoInfo') ? mockPartialPath : ''}${apiMap.queryVideoInfo}`, data)  
}
  
// 盒子信息
export const querySkuInfo = (data: { unionid: string }) => {
  return request.post(
    `${useMockList.includes("querySkuInfo") ? mockPartialPath : ""}${
      apiMap.querySkuInfo
    }`,
    data
  );
};
// 盒子list
export const querySkuList = (data: {
  column_unionid: string;
  page: number;
  limit: number;
}) => {
  return request.post(
    `${useMockList.includes("querySkuList") ? mockPartialPath : ""}${
      apiMap.querySkuList
    }`,
    data
  );
};

// 获取最新安装包
export const getVersionInfo = () => {
  return request.post("/v1/version/version-h5");
};

// 信息收集清单 一级菜单
export const getProfileList = (data:{}) => {
  return request.post(
    `${useMockList.includes("getProfileList") ? mockPartialPath : ""}${
      apiMap.getProfileList
    }`,
    data)
}
// 信息收集清单 二级菜单
export const getProfileItem = (data:{
  collection_key:string
}) => {
  return request.post(
    `${useMockList.includes("getProfileItem") ? mockPartialPath : ""}${
      apiMap.getProfileItem
    }`,
    data)
}
// 信息收集清单 三级菜单
export const getProfileContent = (data:{}) => {
  return request.post(
    `${useMockList.includes("getProfileContent") ? mockPartialPath : ""}${
      apiMap.getProfileContent
    }`,
    data)
}

// 根据试卷id获取试卷内容
export const getPaperInfo = (paper_id: string) => {
  return request.get(
    `${useMockList.includes("getPaperInfo") ? mockPartialPath : ""}${
      apiMap.getPaperInfo
    }`,
    {paper_id})
}
export const submitAnswer = (data:{}) => {
  return request.post(
    `${useMockList.includes("submitAnswer") ? mockPartialPath : ""}${
      apiMap.submitAnswer
    }`,
    data)
}

// 删除笔记
export const deleteNote = (data) => {
  return request.get('/bookapi/v1/user/content/delete',data)
}
// 获取笔记
export const getNoteInfo = (data) => {
  return request.get('/bookapi/v1/user/content',data)
}
// 删除笔记
export const uploadNote = (data) => {
  return request.post('/bookapi/v1/user/content/upload', data)
}
// 在线答题上传试卷进度
export const uploadLearnProgress = (data) => {
  return request.post('/v1/learn/upload', data)
}